import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox"];

  declare readonly checkboxTargets: HTMLInputElement[];

  onClick(): void {
    this.checkboxTargets.forEach((cb) => (cb.checked = true));
  }
}
